import type { TranslationKeys } from './en';

export const tr: TranslationKeys = {
  // ── Ortak ─────────────────────────────────────────────────────────────────
  back: '← GERİ',
  loading: 'YÜKLENİYOR',
  loadingDots: 'YÜKLENİYOR...',
  vs: 'VS',
  or: 'VEYA',
  leave: 'AYRIL',
  exp: 'EXP',
  lvl: 'LVL',
  copied: 'KOPYALANDİ!',
  dicepit: 'DICEPIT',
  joiningRoom: 'ODAYA KATILINIYOR...',
  connecting: 'Bağlanıyor...',
  online: 'ÇEVRİMİÇİ',
  connectingDots: 'BAĞLANIYOR...',
  redirecting: 'YÖNLENDİRİLİYOR...',
  userDataReset: '✓ KULLANICI VERİLERİ SIFIRLANDI',

  // ── Menü ──────────────────────────────────────────────────────────────────
  practice: 'ANTRENMAN',
  practiceNoExp: 'EXP YOK — BECERİLERİNİ GELİŞTİR',
  easy: 'KOLAY',
  normal: 'NORMAL',
  hard: 'ZOR',
  turnTimeout: 'HAMLE SÜRESİ',
  seconds: 'SANİYE',
  multiplayer: 'ÇOKLU OYUNCU',
  playerOnline: (count: number) => `${count} OYUNCU ÇEVRİMİÇİ`,
  searching: 'ARANIYOR...',
  quickMatch: 'HIZLI MAÇ',
  createRoom: 'ODA OLUŞTUR',
  roomCode: 'ODA KODU',
  join: 'KATIL',
  failedMatch: 'Eşleşme bulunamadı. Tekrar dene.',
  failedCreateRoom: 'Oda oluşturulamadı. Tekrar dene.',
  enterRoomCode: 'Oda kodunu gir',
  roomFull: 'Oda dolu',
  gameAlreadyStarted: 'Oyun zaten başlamış',
  roomNoLongerExists: 'Oda artık mevcut değil',
  roomNotFound: 'Oda bulunamadı',
  menuPractice: 'ANTRENMAN',
  menuMultiplayer: 'ÇOKLU OYUNCU',
  menuHowToPlay: 'NASIL OYNANIR',
  menuRecords: 'KAYITLAR',
  menuLeaderboard: 'SKOR TABLOSU',
  menuSettings: 'AYARLAR',
  legal: 'YASAL',
  security: 'GÜVENLİK',
  signUp: 'KAYIT OL',
  guestSaveHint: 'EXP VE İSTATİSTİKLERİN SADECE BU CİHAZDA',
  guestSaveCta: 'KAYDETMEK İÇİN KAYIT OL',
  expFormat: (exp: number, threshold: number) => `${exp} / ${threshold} EXP`,
  lvlFormat: (level: number) => `SVY ${level}`,

  // ── Sloganlar ─────────────────────────────────────────────────────────────
  slogans: [
    'Arenadan Sağ Çık',
    'Sadece Biri Döner',
    "Çukura Gir. Çıkışını Kazan.",
    'Zarla Savaş',
    'Çukurda Merhamet Yok',
    "Arenadan Ayrıl ya da Kırıl",
  ],

  // ── Oyun ───────────────────────────────────────────────────────────────────
  rolling: 'ZARLANIYOR...',
  opponentRolling: 'RAKİP ZARLIYOR...',
  placeDie: (timer: number | null) => `ZARINI YERLEŞTİR!${timer !== null ? ` ${timer}sn` : ''}`,
  opponentPlacing: (timer: number | null) => `RAKİP YERLEŞTİRİYOR...${timer !== null ? ` ${timer}sn` : ''}`,
  waitingForOpponent: 'Rakip bekleniyor...',
  leaveGame: 'OYUNDAN AYRIL?',
  leaveWarning: 'Devam eden bir oyundan ayrılmak',
  defeat: 'YENİLGİ',
  stay: 'KAL',
  rematchQuestion: 'RÖVANŞ?',
  rematchWants: 'Rakibin',
  rematch: 'RÖVANŞ',
  rematchExclaim: 'RÖVANŞ İSTİYOR!',
  decline: 'REDDET',
  accept: 'KABUL ET',
  waitingForOpponentDots: 'RAKİP BEKLENİYOR...',
  pressReady: 'HAZIRA BAS!',
  unready: '✗ HAZIR DEĞİL',
  ready: 'HAZIR?',
  wait: 'BEKLE',
  opponentPlacingShort: 'RAKİP YERLEŞTİRİYOR...',
  pitLord: 'ÇUKUR LORDU',
  opponent: 'RAKİP',
  go: 'BAŞLA!',
  getReady: 'Hazırlan!',
  room: 'Oda',
  multiplayerBattle: 'Çoklu Oyuncu Savaşı',
  matchDice: 'Zarları eşleştir, gücü katla • Düşman zarlarını yok et',
  waiting: 'BEKLENİYOR...',
  rematchDeclined: 'RÖVANŞ REDDEDİLDİ',
  levelLabel: (difficulty: string) => {
    const map: Record<string, string> = { EASY: 'KOLAY', MEDIUM: 'NORMAL', HARD: 'ZOR' };
    return `SEVİYE: ${map[difficulty] || difficulty}`;
  },
  selectJokerValue: 'Zar Değerini Seç:',

  // ── Oyun mesajları (useGame hook) ─────────────────────────────────────────
  msgRolling: 'ZARLANIYOR...',
  msgYourTurn: 'SENİN SIRAN',
  msgSlaughtered: 'KATLİAM!',
  msgLordRolling: 'LORD ZARLIYOR...',
  msgCrushed: 'EZİLDİN!',
  msgVictory: 'ZAFER!',
  msgDefeat: 'YENİLGİ...',
  msgTie: 'BERABERLİK Mİ? LANET!',
  msgReadyToRoll: 'ZARLAMAYA HAZIR?',
  msgBattleBegins: 'SAVAŞ BAŞLIYOR!',

  // ── Ayarlar ───────────────────────────────────────────────────────────────
  settings: 'AYARLAR',
  audio: 'Ses',
  music: 'Müzik',
  musicOff: 'MÜZİK: KAPALI',
  musicOn: 'MÜZİK: AÇIK',
  soundOff: 'SES: KAPALI',
  soundOn: 'SES: AÇIK',
  diceSpeed: 'Zar Hızı',
  arenaTheme: 'Arena Teması',
  warriorName: 'Savaşçı Adı',
  signUpToChooseName: 'ADINI SEÇMEK İÇİN KAYIT OL',
  nameCannotBeChanged: 'İSİM DEĞİŞTİRİLEMEZ',
  account: 'Hesap',
  playingAsGuest: 'MİSAFİR OLARAK OYNUYORSUN — İLERLEMENİ KAYDETMEK İÇİN KAYIT OL',
  createAccount: 'HESAP OLUŞTUR',
  signedInAs: 'GİRİŞ YAPILAN',
  signOut: 'ÇIKIŞ YAP',
  deleteAccount: 'HESABI SİL',
  deleteAccountConfirm: 'HESABINIZI KALICI OLARAK SİLMEK İSTEDİĞİNİZDEN EMİN MİSİNİZ?',
  deleteAccountWarning: 'Tüm oyun verileriniz, maç geçmişiniz ve ilerlemeniz kalıcı olarak silinecektir. Bu işlem geri alınamaz.',
  yesDelete: 'EVET, SİL',
  cancel: 'İPTAL',
  deletingAccount: 'SİLİNİYOR...',
  accountDeleted: 'HESAP SİLİNDİ',
  language: 'Dil',

  // ── Kimlik Doğrulama ─────────────────────────────────────────────────────
  createAccountTitle: 'HESAP OLUŞTUR',
  signInTitle: 'GİRİŞ YAP',
  resetPasswordTitle: 'ŞİFRE SIFIRLA',
  signIn: 'GİRİŞ YAP',
  forgotPw: 'ŞİFREMİ UNUTTUM',
  allFieldsRequired: 'Tüm alanlar gereklidir',
  passwordMinLength: (n: number) => `Şifre en az ${n} karakter olmalıdır`,
  usernameMaxLength: (n: number) => `Kullanıcı adı en fazla ${n} karakter olabilir`,
  signUpFailed: 'Kayıt başarısız. Tekrar dene.',
  emailPasswordRequired: 'E-posta ve şifre gereklidir',
  signInFailed: 'Giriş başarısız. Bilgilerini kontrol et.',
  enterEmail: 'E-posta adresini gir',
  resetEmailSent: 'Şifre sıfırlama bağlantısı gönderildi! E-postanı kontrol et.',
  failedResetEmail: 'Sıfırlama e-postası gönderilemedi. Tekrar dene.',
  email: 'E-posta',
  emailPlaceholder: 'SENIN@EPOSTA.COM',
  username: 'Kullanıcı Adı',
  warriorNamePlaceholder: 'SAVAŞÇI ADI',
  characters: (current: number, max: number) => `${current}/${max} KARAKTER`,
  password: 'Şifre',
  minimumChars: (n: number) => `EN AZ ${n} KARAKTER`,
  creating: 'OLUŞTURULUYOR...',
  alreadyHaveAccount: 'ZATEN HESABIN VAR MI?',
  signingIn: 'GİRİŞ YAPILIYOR...',
  forgotPassword: 'ŞİFRENİ Mİ UNUTTUN?',
  resetIt: 'SIFIRLA',
  noAccount: 'HESABIN YOK MU?',
  enterEmailReset: 'E-POSTANI GİR, SANA SIFIRLAMA BAĞLANTISI GÖNDERELİM',
  sending: 'GÖNDERİLİYOR...',
  sendResetLink: 'SIFIRLAMA BAĞLANTISI GÖNDER',
  rememberedPassword: 'ŞİFRENİ HATIRLADIN MI?',

  // ── Şifre Sıfırlama ─────────────────────────────────────────────────────
  newPassword: 'YENİ ŞİFRE',
  enterNewPassword: 'Yeni bir şifre gir',
  passwordsNoMatch: 'Şifreler eşleşmiyor',
  failedUpdatePassword: 'Şifre güncellenemedi. Tekrar dene.',
  passwordUpdated: 'ŞİFRE BAŞARIYLA GÜNCELLENDİ!',
  newPasswordLabel: 'Yeni Şifre',
  confirmPassword: 'Şifre Onayı',
  updating: 'GÜNCELLENİYOR...',
  updatePassword: 'ŞİFREYİ GÜNCELLE',

  // ── Geçmiş ────────────────────────────────────────────────────────────────
  pitRecords: 'ÇUKUR KAYITLARI',
  noBattles: 'SAVAŞ KAYDI YOK...',
  victory: 'ZAFER',
  draw: 'BERABERE',

  // ── Skor Tablosu ──────────────────────────────────────────────────────────
  leaderboard: 'SKOR TABLOSU',
  player: 'OYUNCU',
  wld: 'G / M / B',
  noPlayers: 'HENÜZ OYUNCU YOK...',
  rankFirst: '1.',
  rankSecond: '2.',
  rankThird: '3.',
  you: '(SEN)',

  // ── Sohbet ────────────────────────────────────────────────────────────────
  chat: 'Sohbet',
  msgCount: (count: number) => `${count} mesaj`,
  noMessages: 'Henüz mesaj yok...',
  chatYou: 'SEN',
  typeMessage: 'Bir mesaj yaz...',
  send: 'Gönder',

  // ── Çerez Onayı ───────────────────────────────────────────────────────────
  cookieNotice: 'Çerez Bildirimi',
  cookieDescription: "DicePit'i nasıl kullandığını anlamak ve oyun deneyimini iyileştirmek için Google Analytics çerezleri kullanıyoruz. Kişisel veriler satılmaz veya reklamcılarla paylaşılmaz.",
  cookieAccept: 'Kabul Et',
  cookieDecline: 'Reddet',

  // ── Oda hataları (App.tsx) ────────────────────────────────────────────────
  roomIsFull: 'ODA DOLU',
  gameAlreadyStartedUpper: 'OYUN ZATEN BAŞLAMIŞ',
  roomNoLongerExistsUpper: 'ODA ARTIK MEVCUT DEĞİL',
  roomNotFoundUpper: 'ODA BULUNAMADI',
  usernameTaken: 'Kullanıcı adı zaten alınmış. Farklı bir isim seç.',

  // ── Hız etiketleri ────────────────────────────────────────────────────────
  speedSlow: 'YAVAŞ',
  speedNormal: 'NORMAL',
  speedFast: 'HIZLI',

  // ── Nasıl Oynanır ───────────────────────────────────────────────────────
  howToPlay: 'NASIL OYNANIR',
  aboutTheGame: 'OYUN HAKKINDA',
  htpGoalTitle: '1. Amaç',
  htpGoalText: '3x3 ızgaranı zarlarla doldur. Sonunda en yüksek toplam puana sahip olan oyuncu Çukurdaki savaşı kazanır.',
  htpScoringTitle: '2. Puan Çarpanları',
  htpScoringText: 'Aynı değerde birden fazla zarı tek bir sütuna yerleştirdiğinde, toplamları eşleşme sayısıyla çarpılır:',
  htpCombatTitle: '3. Savaş (Katliam)',
  htpCombatText1: 'Bir sütuna zar yerleştirmek, rakibin eşleşen sütunundaki aynı değerdeki tüm zarları',
  htpCombatRemove: 'KALDIRIR',
  htpCombatText2: '. Bunu puanlarını sabote etmek için kullan!',
  htpProgressionTitle: '4. Çukur İlerlemesi',
  htpProgressionText: 'Maçlar kazan, EXP kazan ve seviye atla. Yüksek zorluk ve büyük puan farkları bonus EXP verir. Dikkat: Kaybetmek deneyimini eritir.',
  htpSuperDiceTitle: '5. Süper Zar Modu',
  htpSuperDiceText: 'Süper Zar modunda, normal zar yerine %20 ihtimalle özel bir zar gelebilir:',
  htpJoker: 'Joker: İstediğiniz bir yere yerleştirip değerini (1-6) siz seçin.',
  htpShield: 'Kalkan: Bir sütunu 2 tur boyunca yok edilmekten korur.',
  htpBomb: 'Bomba: Hem sizin hem de rakibinizin o sütunundaki tüm zarları tamamen temizler.',
  htpReroll: 'Yeniden Zar Atma: Size ardışık olarak iki normal zar verir.',
  htpWhatIs: 'DicePit Nedir?',
  htpWhatIsText: 'DicePit, antik',
  htpWhatIsText2: " oyunundan ilham alan ücretsiz bir çevrimiçi çoklu oyunculu zar savaşı oyunudur. İki oyuncu karşı karşıya gelir, zarlarını ızgaralarına yerleştirirken stratejik olarak rakibin zarlarını yok eder. Öğrenmesi kolay, ustalaşması şaşırtıcı derecede derin.",
  htpOriginsTitle: 'Antik Kökenler',
  htpOriginsText1: "Aşık Kemiği (Knucklebones), en az MÖ 5000'e kadar uzanan, insanlık tarihinin en eski oyunlarından biridir. Başlangıçta koyunların bilek kemikleri (astragali) ile oynanan oyun, antik Yunanistan, Roma ve dünya genelinde sayısız kültürde popülerdi — Moğol bozkırlarından Polinezya adalarına kadar.",
  htpOriginsText2: 'Oyun Platon ve Herodotos tarafından bahsedilmiştir. Sofokles, icadını Truva Savaşı sırasında efsanevi kahraman Palamedes\'e atfederken, Platon Mısır tanrısı Thoth\'a mal etmiştir. Antik Yunanlılar ve Romalılar eğlence, kumar ve hatta kehanet için oynardı.',
  htpCotlTitle: 'Cult of the Lamb',
  htpCotlText1: 'Knucklebones\'un modern dijital yeniden doğuşu büyük ölçüde',
  htpCotlName: 'Cult of the Lamb',
  htpCotlText2: " sayesindedir — Massive Monster'ın 2022 roguelike oyunu. Cult of the Lamb'da Knucklebones, NPC'lere karşı oynanan bir zar mini oyunu olarak yer alır — iki rakip sırayla zar atıp 3x3 ızgaraya yerleştirir, rakibin sütunundaki eşleşen zarlar yok edilir.",
  htpCotlText3: "Bu mini oyun bir hayran favorisi haline geldi; birçok oyuncu ana görevden çok Knucklebones masasında vakit geçirdi. Şans ve stratejinin bağımlılık yaratan karışımı, antik oyunu bu kadar kalıcı kılan şeyi yakaladı — ve DicePit dahil bir dizi bağımsız versiyonun doğmasına ilham verdi.",
  htpCulturesTitle: 'Kültürler Arası Bir Oyun',
  htpCulturesIntro: "Knucklebones'un varyasyonları dünyanın neredeyse her köşesinde bulunur:",
  htpBrowsersTitle: "Kemikten Tarayıcıya",
  htpBrowsersText1: "DicePit, Knucklebones'u zamansız kılan temel mekaniği — kendi puanını oluşturma ile rakibinin puanını yok etme arasındaki gerilimi — alıp gerçek zamanlı bir çevrimiçi arenaya taşır. İndirme yok, kurulum yok. Sadece zar at, yerleştir, katlet ve skor tablosunda yüksel.",
  htpBrowsersText2: '5.000 yıllık zar oyunu, bir tarayıcı sekmesine damıtılmış.',

  // ── Yasal ───────────────────────────────────────────────────────────────
  privacyPolicy: 'GİZLİLİK POLİTİKASI',
  termsOfService: 'HİZMET KOŞULLARI',
  legalLastUpdated: 'Son güncelleme: Şubat 2026',
  privacyIntro: 'DicePit ("biz", "bizim") Riza Sabuncu tarafından işletilen çevrimiçi bir zar savaşı oyunudur. Bu Gizlilik Politikası, dicepit.xyz adresindeki Hizmetimizi ("Hizmet") kullanırken hangi bilgileri topladığımızı, nasıl kullandığımızı ve verilerinizle ilgili haklarınızı açıklar.',
  privacyAgree: 'Hizmeti kullanarak, bu politikada açıklanan bilgi toplama ve kullanımını kabul etmiş olursunuz. Kabul etmiyorsanız lütfen Hizmeti kullanmayınız.',
  privacyS1Title: '1. TOPLANAN BİLGİLER',
  privacyS1aTitle: 'A. Sizin Sağladığınız Bilgiler',
  privacyS1aName: 'Oynarken bir görüntü adı seçersiniz. Bu ad veritabanımızda saklanır ve çoklu oyuncu oturumlarında gösterilir.',
  privacyS1aEmail: 'Hesabınızı güvence altına almak için isteğe bağlı olarak e-posta adresi ve şifre ile kayıt olabilirsiniz. Kayıt olmazsanız otomatik olarak anonim bir hesap oluşturulur.',
  privacyS1aChat: 'Çoklu oyuncu modunda sohbet mesajları gönderebilirsiniz. Bu mesajlar oyuncu kimliğiniz, görüntü adınız ve oda tanımlayıcısı ile birlikte kaydedilir.',
  privacyS1bTitle: 'B. Otomatik Olarak Toplanan Bilgiler',
  privacyS1bIp: 'Çoklu oyuncu modunda bir sohbet mesajı gönderdiğinizde, IP adresiniz moderasyon ve kötüye kullanım önleme amacıyla mesajla birlikte kaydedilir.',
  privacyS1bProgress: 'Seviyeniz, deneyim puanlarınız (EXP), galibiyetleriniz, mağlubiyetleriniz ve maç geçmişiniz sunucularımızdaki veritabanında saklanır.',
  privacyS1bLocal: 'Oyun ayarlarını (tema, ses tercihleri, zar hızı) ve çerez onay tercihinizi saklamak için tarayıcınızın localStorage özelliğini kullanırız. Bu veriler cihazınızda kalır.',
  privacyS1bPlayerId: 'Oturumlar arasında sizi tanımlamak için kimlik doğrulama sistemimiz aracılığıyla rastgele oluşturulan bir UUID oluşturulur. E-posta adresiyle kayıt olmadığınız sürece bu, gerçek kimliğinizle ilişkilendirilmez.',
  privacyS1bSentry: 'Uygulamada hatalar oluştuğunda, hata ayrıntılarını (tür, mesaj, yığın izleme), tarayıcı ve işletim sistemi bilgilerinizi (ad, sürüm), ekran çözünürlüğünü, hatanın oluştuğu sayfa URL\'sini ve hataya yol açan son kullanıcı eylemlerini (tıklamalar, sayfa gezintileri ve ağ istekleri gibi) otomatik olarak toplarız. IP adresiniz Sentry sunucuları tarafından işlenebilir ancak 90 günden fazla saklanmaz.',
  privacyS2Title: '2. BİLGİLERİNİZİ NASIL KULLANIRIZ',
  privacyS2Intro: 'Toplanan bilgileri aşağıdaki amaçlarla kullanırız:',
  privacyS2Items: [
    'Çoklu oyuncu oyun odalarını işletmek (eşleştirme, gerçek zamanlı oyun, sohbet)',
    'Sohbeti denetlemek ve kötüye kullanımı önlemek (IP kaydı)',
    'Oyun ilerlemenizi veritabanımızda tutmak (seviye, EXP, maç sonuçları)',
    'Hizmetteki hataları izlemek ve düzeltmek (Sentry)',
    'Kullanım kalıplarını analiz etmek ve Hizmeti geliştirmek (Google Analytics)',
    'Hizmeti sağlamak ve iyileştirmek',
  ],
  privacyS2NoSell: 'Kişisel bilgilerinizi pazarlama amacıyla üçüncü taraflara satmaz, kiralamaz veya paylaşmayız.',
  privacyS2aTitle: '2A. ÇEREZLER VE ONAY',
  privacyS2aCookie1: 'DicePit\'i ilk ziyaret ettiğinizde, analitik çerezleri ayarlamadan önce onayınızı isteriz. Google Analytics çerezleri yalnızca çerez bildirim bannerında "Kabul Et" seçeneğine tıklarsanız yüklenir.',
  privacyS2aCookie2: 'Kabul ederseniz, benzersiz kullanıcıları ayırt etmek ve istek oranlarını sınırlamak için _ga ve _ga_* gibi çerezler ayarlanır. Bunlar sırasıyla 2 yıl ve 24 saat sonra sona erer.',
  privacyS2aCookie3: 'Reddederseniz, hiçbir analitik çerezi ayarlanmaz ve Google Analytics tarafından hiçbir kullanım verisi toplanmaz. Tercihiniz yerel olarak saklanır ve gelecekteki ziyaretlerde hatırlanır.',
  privacyS2aCookie4: 'Tercihinizi istediğiniz zaman tarayıcınızın localStorage\'ını temizleyerek değiştirebilirsiniz (bu aynı zamanda çerez onay tercihinizi de sıfırlayacaktır).',
  privacyS3Title: '3. VERİ DEPOLAMA VE GÜVENLİK',
  privacyS3Server: 'Sunucu tarafı veriler (oyuncu profilleri, oyun ilerlemesi, çoklu oyuncu odaları, katılımcılar, maç sonuçları, sohbet mesajları) AWS altyapısında barındırılan bulut veritabanı platformu Supabase üzerinde saklanır. Gerçek zamanlı çoklu oyuncu iletişimi özel bir WebSocket sunucusu aracılığıyla sağlanır. Tüm veriler TLS/SSL ile aktarım sırasında şifrelenir.',
  privacyS3Client: 'İstemci tarafı veriler (oyun ayarları, tema tercihleri, çerez onayı) tarayıcınızın localStorage\'ında saklanır ve cihazınızda kalır. Tarayıcı verilerinizi temizlemek bu bilgileri silecektir.',
  privacyS3Disclaimer: 'Makul güvenlik önlemleri uygulasak da, hiçbir elektronik depolama veya aktarım yöntemi %100 güvenli değildir. Verilerinizin mutlak güvenliğini garanti edemeyiz.',
  privacyS4Title: '4. VERİ SAKLAMA',
  privacyS4Chat: 'Sohbet mesajları ve IP kayıtları moderasyon amacıyla süresiz olarak saklanır. Çoklu oyuncu oda verileri (katılımcılar, oyun durumu) oyun oturumu süresince saklanır ve sonrasında veritabanında kalabilir.',
  privacyS4Sentry: 'Sentry tarafından toplanan hata raporları 90 güne kadar saklanır.',
  privacyS4Local: 'Yerel veriler (ayarlar, tema tercihleri) tarayıcınızın localStorage\'ını temizleyene kadar kalıcıdır. Sunucu tarafı oyun ilerlemesi, silme talebinde bulunana kadar devam eder.',
  privacyS5Title: '5. HAKLARINIZ',
  privacyS5Intro: 'Bulunduğunuz yargı bölgesine bağlı olarak, aşağıdaki haklara sahip olabilirsiniz:',
  privacyS5Items: [
    'Hakkınızda tuttuğumuz kişisel verilere erişim',
    'Yanlış verilerin düzeltilmesini talep etme',
    'Verilerinizin silinmesini talep etme',
    'Verilerinizin işlenmesine itiraz etme veya kısıtlama',
    'Veri taşınabilirliği',
  ],
  privacyS5Contact: 'Bu haklardan herhangi birini kullanmak için aşağıda belirtilen e-posta adresinden bizimle iletişime geçin. 30 gün içinde yanıt vereceğiz.',
  privacyS5Local: 'Yerel veriler (ayarlar, tercihler) için tarayıcınızın localStorage\'ını temizleyerek istediğiniz zaman silebilirsiniz. Sunucu tarafı veriler (oyun ilerlemesi, hesap) için Ayarlar sayfasından hesabınızı kalıcı olarak silebilirsiniz.',
  privacyS6Title: '6. ÇOCUKLARIN GİZLİLİĞİ',
  privacyS6Text: '13 yaşın altındaki çocuklara yönelik bir Hizmet sunmuyoruz. 13 yaşın altındaki çocuklardan bilerek kişisel bilgi toplamayız. 13 yaşın altındaki bir çocuğun bize kişisel bilgi sağladığını öğrenirsek, silmek için adımlar atacağız.',
  privacyS7Title: '7. ÜÇÜNCÜ TARAF HİZMETLERİ',
  privacyS7Intro: 'Hizmet aşağıdaki üçüncü taraf hizmetlerini kullanır:',
  privacyS7NoAds: 'Reklam hizmetleri kullanmıyoruz.',
  privacyS8Title: '8. BU POLİTİKADAKİ DEĞİŞİKLİKLER',
  privacyS8Text: 'Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Değişiklikler bu sayfada güncellenmiş "Son güncelleme" tarihi ile yayınlanacaktır. Değişiklikler yayınlandıktan sonra Hizmeti kullanmaya devam etmeniz, güncellenen politikayı kabul ettiğiniz anlamına gelir.',
  privacyS9Title: '9. İLETİŞİM',
  privacyS9Text: 'Gizlilikle ilgili sorular veya talepler için iletişim:',
  // Koşullar
  termsIntro: 'Bu Hizmet Koşulları ("Koşullar"), Riza Sabuncu ("biz", "bizim") tarafından dicepit.xyz adresinde işletilen çevrimiçi zar savaşı oyunu DicePit\'in ("Hizmet") kullanımınızı düzenler.',
  termsAgree: 'Hizmete erişerek veya kullanarak bu Koşullarla bağlı olmayı kabul edersiniz. Kabul etmiyorsanız Hizmeti kullanmayınız.',
  termsS1Title: '1. UYGUNLUK',
  termsS1Text: 'Hizmeti kullanmak için en az 13 yaşında olmanız gerekmektedir. Hizmeti kullanarak bu yaş gereksinimini karşıladığınızı beyan edersiniz.',
  termsS2Title: '2. HİZMET',
  termsS2Text1: 'DicePit, tek oyunculu (yapay zekaya karşı) ve çoklu oyuncu (diğer oyunculara karşı) modları sunan ücretsiz, tarayıcı tabanlı bir zar oyunudur. Hizmet hiçbir türde garanti olmaksızın "olduğu gibi" ve "mevcut olduğu şekilde" sağlanır.',
  termsS2Text2: 'Hizmeti (veya herhangi bir bölümünü) önceden haber vermeksizin istediğimiz zaman değiştirme, askıya alma veya durdurma hakkını saklı tutarız.',
  termsS3Title: '3. KULLANICI HESAPLARI',
  termsS3Text1: 'Hizmeti ilk ziyaret ettiğinizde, kimlik doğrulama sistemimiz aracılığıyla otomatik olarak anonim bir hesap oluşturulur. Hesabınızı güvence altına almak ve diğer cihazlardan erişmek için isteğe bağlı olarak e-posta adresi ve şifre ile kayıt olabilirsiniz.',
  termsS3Text2: 'Oyun ilerlemeniz (seviye, EXP, galibiyetler, mağlubiyetler) ve oyuncu adınız sunucularımızda saklanır. Oyun ayarları ve tema tercihleri tarayıcınızda yerel olarak saklanır. Tarayıcı önbelleğinin temizlenmesi nedeniyle yerel ayarların kaybından sorumlu değiliz.',
  termsS3Text3: 'Hesabınız altında gerçekleşen tüm etkinliklerden siz sorumlusunuz, anonim veya kayıtlı olması fark etmez.',
  termsS4Title: '4. KABUL EDİLEBİLİR KULLANIM',
  termsS4Intro: 'Hizmeti kullanırken aşağıdakileri YAPMAMAYII kabul edersiniz:',
  termsS4Items: [
    'Sohbet özelliğini diğer oyuncuları taciz etmek, tehdit etmek veya kötüye kullanmak için kullanmak',
    'Sohbet yoluyla spam, saldırgan veya yasa dışı içerik göndermek',
    'Hizmeti veya altyapısını istismar etmeye, hacklemye veya bozmaya çalışmak',
    'Hizmetle etkileşim için bot, komut dosyası veya otomasyon kullanmak',
    'Diğer oyuncuları taklit etmek veya kimliğinizi yanlış beyan etmek',
    'Diğer oyuncuların oyun keyfini engellemek',
  ],
  termsS4Ban: 'Bu kuralların ihlali, IP adresinizin önceden haber verilmeksizin Hizmetten yasaklanmasına neden olabilir.',
  termsS5Title: '5. SOHBET VE KULLANICI İÇERİĞİ',
  termsS5Text1: 'Çoklu oyuncu sohbet özelliği oyuncular arasında iletişim sağlar. Tüm sohbet mesajları, moderasyon amacıyla IP adresinizle birlikte kaydedilir.',
  termsS5Text2: 'Mesajlarınızın içeriğinden yalnızca siz sorumlusunuz. Sohbet mesajlarını inceleme, silme veya kısıtlama ve bu Koşulları ihlal eden kullanıcıları yasaklama hakkını saklı tutarız.',
  termsS5Text3: 'Bir sohbet mesajı göndererek, mesajınızı oyun oturumu içinde saklamamız ve görüntülememiz için bize münhasır olmayan, telif ücretsiz bir lisans vermiş olursunuz.',
  termsS6Title: '6. FİKRİ MÜLKİYET',
  termsS6Text1: 'Hizmeti oluşturan tüm içerik, tasarım, kod, grafikler, sesler ve diğer materyaller Riza Sabuncu\'nun mülkiyetindedir ve geçerli telif hakkı ve fikri mülkiyet yasaları tarafından korunmaktadır.',
  termsS6Text2: 'Açık yazılı izin olmaksızın Hizmeti kopyalayamaz, değiştiremez, dağıtamaz, satamaz veya Hizmete dayalı türev çalışmalar oluşturamazsınız.',
  termsS7Title: '7. GARANTİ REDDİ',
  termsS7Text1: 'HİZMET, TİCARİ ELVERİŞLİLİK, BELİRLİ BİR AMACA UYGUNLUK VE İHLAL ETMEME GARANTİLERİ DAHİL ANCAK BUNLARLA SINIRLI OLMAMAK ÜZERE, AÇIK VEYA ZIMNİ HİÇBİR TÜRDE GARANTİ OLMAKSIZIN "OLDUĞU GİBİ" VE "MEVCUT OLDUĞU ŞEKİLDE" SAĞLANMAKTADIR.',
  termsS7Text2: 'Hizmetin kesintisiz, hatasız veya güvenli olacağını garanti etmiyoruz. Herhangi bir veri kaybı, oyun kesintisi veya teknik sorunlardan sorumlu değiliz.',
  termsS8Title: '8. SORUMLULUK SINIRLAMASI',
  termsS8Text1: 'YASALARIN İZİN VERDİĞİ AZAMİ ÖLÇÜDE, HİZMETİ KULLANMANIZDAN KAYNAKLANAN HİÇBİR DOLAYLI, ARIZİ, ÖZEL, SONUÇ NİTELİĞİNDE VEYA CEZAİ ZARARDAN SORUMLU OLMAYACAĞIZ.',
  termsS8Text2: 'Hizmetle ilgili herhangi bir talep için toplam sorumluluğumuz, Hizmeti kullanmak için ödediğiniz tutarı (Hizmet ücretsiz olduğundan sıfırdır) aşmayacaktır.',
  termsS9Title: '9. FESİH',
  termsS9Text1: 'Hizmete erişiminizi herhangi bir zamanda, herhangi bir nedenle, önceden haber vermeksizin sona erdirme veya kısıtlama hakkını saklı tutarız. Fesih üzerine, Hizmeti kullanma hakkınız derhal sona erer.',
  termsS9Text2: 'Fikri mülkiyet, sorumluluk reddi, sorumluluk sınırlaması ve geçerli hukuk ile ilgili bölümler bu Koşulların feshinden sonra da geçerli kalır.',
  termsS10Title: '10. GEÇERLİ HUKUK',
  termsS10Text: 'Bu Koşullar, kanun ihtilafı ilkelerine bakılmaksızın Türkiye yasalarına göre yönetilir ve yorumlanır. Bu Koşullardan doğan tüm uyuşmazlıklar Türkiye mahkemelerinin münhasır yargı yetkisine tabi olacaktır.',
  termsS11Title: '11. KOŞULLARDA DEĞİŞİKLİKLER',
  termsS11Text: 'Bu Koşulları zaman zaman güncelleyebiliriz. Değişiklikler bu sayfada güncellenmiş tarih ile yayınlanacaktır. Değişiklikler yayınlandıktan sonra Hizmeti kullanmaya devam etmeniz, güncellenen Koşulları kabul ettiğiniz anlamına gelir.',
  termsS12Title: '12. İLETİŞİM',
  termsS12Text: 'Bu Koşullarla ilgili sorular için iletişim:',

  // ── Güvenlik ────────────────────────────────────────────────────────────
  secBountyTitle: 'BUG BOUNTY PROGRAMI',
  secBountyText: 'DicePit güvenliği ciddiye alır. Oyunumuzda bir güvenlik açığı keşfederseniz, bunu duymak isteriz. Sorumlu bildirimi teşvik etmek için açık bir bug bounty programı yürütüyoruz.',
  secReportTo: 'Bildirim:',
  secScopeTitle: 'KAPSAM',
  secScopeIntro: 'Aşağıdaki hedefler kapsam dahilindedir:',
  secScopeApp: 'Tüm DicePit web uygulaması dahil:',
  secScopeItems: [
    'Frontend uygulaması ve istemci tarafı mantığı',
    'WebSocket oyun sunucusu (ws.dicepit.xyz) ve gerçek zamanlı iletişim',
    'Veritabanı etkileşimleri ve RLS politikaları',
    'Kimlik doğrulama ve oturum yönetimi',
    'Skor tablosu ve EXP/sıralama sistemi bütünlüğü',
    'Sohbet sistemi',
  ],
  secInScope: '• KAPSAM DAHİLİ',
  secOutOfScope: 'KAPSAM DIŞI',
  secOutItems: [
    'Üçüncü taraf hizmetleri (Supabase altyapısı, Cloudflare, Google Analytics)',
    'Hizmet Reddi (DoS/DDoS) saldırıları',
    'Sosyal mühendislik saldırıları',
    'Diğer kullanıcıların cihazlarına yönelik saldırılar',
  ],
  secRewardTitle: 'ÖDÜL',
  secRewardIntro: 'Geçerli güvenlik açığı bildirimleri şu ödülle ödüllendirilir:',
  secRewardNote: 'Ödül geçerli, benzersiz güvenlik açığı başınadır. Sadece Türkiye. Kargo dahil değildir.',
  secRulesTitle: 'KURALLAR',
  secRulesItems: [
    'Hizmeti veya diğer oyuncuların deneyimini bozmayın',
    'Diğer oyuncuların verilerine erişmeyin, değiştirmeyin veya silmeyin',
    'Açık, ayrıntılı bir açıklama ve yeniden üretme adımları sağlayın',
    'Kamuya açıklamadan önce düzeltmemiz için makul süre tanıyın',
    'Benzersiz güvenlik açığı başına bir ödül',
    'Bir güvenlik açığının ilk bildireni ödülü alır',
  ],
  secFameTitle: 'ONUR TABLOSU',
  secFameIntro: 'DicePit\'in güvenliğini sağlamaya yardımcı olan araştırmacılara teşekkürler:',

  // ── Tutorial ──────────────────────────────────────────────────────────────
  tutS1: 'Hoş geldin! Bu senin ızgaran. Puan kazanmak için zarlarla doldur.',
  tutS2: 'Bu da rakibinin ızgarası. Hadi başlayalım!',
  tutS3: '3 attın! ORTA sütuna yerleştir.',
  tutS4: 'Rakibin bir zar yerleştiriyor...',
  tutS5: 'Yine 3! Aynı sütuna koy, puanın katlansın!',
  tutS6: 'Rakibin orta sütuna 3 yerleştiriyor...',
  tutS7: 'Yine 3! Orta sütuna koy ve rakibin 3\'ünü YOK ET!',
  tutS8: 'KATLİAM! Senin 3\'ün rakibin eşleşen 3\'ünü yok etti!',
  tutS9: 'Bir sütunda üç 3 = (3+3+3) × 3 = 27 puan! Aynı değerleri üst üste koy.',
  tutS10: 'Savaşa hazırsın! Çukur\'da bol şans.',
  tutNext: 'İLERİ',
  tutGotIt: 'ANLADIM!',
  tutSkip: 'TUTORIAL\'I GEÇ',
  tutPlace: 'PARLAYAN SÜTUNA DOKUN',
  tutTitle: 'TUTORIAL',
  tutMpTitle: 'İLK DEFA MI?',
  tutMpText: 'Önce kısa bir tutorial oynayarak oyunu öğrenmeni öneriyoruz!',
  tutMpPlay: 'TUTORIAL OYNA',
  tutMpSkip: 'GEÇ, BİLİYORUM',
  superDiceReleasePopupTitle: 'SUPER DICE YAYINLANDI!',
  superDiceReleasePopupText: 'Yepyeni bir oyun modu geldi! Joker, Kalkan, Bomba ve Yeniden Zar Atma özelliklerini dene.',
  superDiceReleasePopupPlay: 'SUPER DICE OYNA',
  superDiceReleasePopupClose: 'BELKİ SONRA',
};
